import CreateRecordDrawer from "components/Drawers/Records/CreateRecordDrawer";
import UpdateSubitemDrawer from "components/Drawers/Subitems/UpdateSubitemDrawer";
import pluralize from "pluralize";
import { useState } from "react";
import { Button } from "reactstrap";
import { Tooltip, Whisper } from "rsuite";

const AddRecord = ({
  currentModule,
  setKeepOpen,
  setHideReference,
  setCreatedRecords,
  selectedSubitemParent,
  setSelectedSubitemParent,
  modulesMap,
  currentKey,
}) => {
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);

  return (
    <>
      <Whisper
        trigger="hover"
        placement="left"
        delayOpen={400}
        speaker={
          <Tooltip>
            Create a new{" "}
            {currentModule?.Name ? pluralize(currentModule?.Name, 1) : "record"}
          </Tooltip>
        }
      >
        <Button
          onClick={onOpen}
          size="sm"
          outline
          color="primary"
          className="btn-icon-only ml-2"
        >
          <i className="mdi mdi-plus"></i>
        </Button>
      </Whisper>
      {!selectedSubitemParent && (
        <CreateRecordDrawer
          open={createDrawerOpen}
          onClose={onClose}
          onCreate={(newRecord) => {
            setCreatedRecords((prev) => [...prev, newRecord]);
            onClose();
          }}
          moduleAPIName={currentModule?.APIName}
        />
      )}
      {selectedSubitemParent && (
        <UpdateSubitemDrawer
          open={createDrawerOpen}
          onClose={onClose}
          parentRecord={selectedSubitemParent}
          fieldSchema={modulesMap?.get(currentKey)?.SubitemSchema}
          addSubitemMode
          onCreate={(newRecord) => setSelectedSubitemParent(newRecord)}
        />
      )}
    </>
  );

  function onOpen() {
    setCreateDrawerOpen(true);
    setKeepOpen(true);
    setHideReference(true);
  }

  function onClose() {
    setCreateDrawerOpen(false);
    setKeepOpen(false);
    setHideReference(false);
  }
};

export default AddRecord;
